import { render, staticRenderFns } from "./SubjectsIndex.vue?vue&type=template&id=f8256bb8"
import script from "./SubjectsIndex.js?vue&type=script&lang=js&external"
export * from "./SubjectsIndex.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports